export default "__VITE_ASSET__CU5FNY9A__"